import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle, Shield, Zap, User } from 'lucide-react';
import { Section } from '../ui/Section';
import { OpenAccountButton } from '../ui/OpenAccountButton';
import { SUPPORTED_CURRENCIES } from '../../utils/constants';
import styles from './CurrencyList.module.css';
import payrollStyles from './PayrollSection.module.css';

export const CurrencyList: React.FC = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <User size={32} />,
      title: t('home.hero.feature4Title'),
      description: t('home.hero.feature4Description'),
    },
    {
      icon: <CheckCircle size={32} />,
      title: t('home.hero.feature1Title'),
      description: t('home.hero.feature1Description'),
    },
    {
      icon: <Shield size={32} />,
      title: t('home.hero.feature2Title'),
      description: t('home.hero.feature2Description'),
    },
    {
      icon: <Zap size={32} />,
      title: t('home.hero.feature3Title'),
      description: t('home.hero.feature3Description'),
    },
  ];

  return (
    <Section className={styles.currencySection}>
      <div className={styles.currencyContainer}>
        <div className={styles.joinText}>
          <h3>{t('home.hero.joinText')}</h3>
        </div>
        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.featureIcon}>{feature.icon}</div>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
        <div className={payrollStyles.payrollContent}>
          <h3 className={payrollStyles.title}>{t('home.payroll.title')}</h3>
          <p className={payrollStyles.description}>{t('home.payroll.description1')}</p>
          <p className={payrollStyles.description}>{t('home.payroll.description2')}</p>
          <OpenAccountButton 
            className={payrollStyles.createAccountButton}
            size="large"
          />
        </div>
        <h3 className={styles.sectionTitle}>{t('home.currencies.title')}</h3>
        <div className={styles.currencyGrid}>
          {SUPPORTED_CURRENCIES.map((currency) => (
            <div key={currency} className={styles.currencyItem}>
              {currency}
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

